import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorInvalidFieldConfig: {
		id: 'issue-field-cmdb-object.error.error-invalid-field-config',
		defaultMessage:
			'This field needs to be configured with an object schema. Please contact your admin to configure this field.',
		description:
			'Error message for non-admin users when the CMDB field does not have a valid object shema configured.',
	},
	errorInvalidFieldConfigAdmin: {
		id: 'issue-field-cmdb-object.error.error-invalid-field-config-admin',
		defaultMessage: 'This field needs to be configured with an object schema.',
		description:
			'Error message for admin users when the CMDB field does not have a valid object shema configured.',
	},
	errorInvalidFieldConfigAdminLink: {
		id: 'issue-field-cmdb-object.error.error-invalid-field-config-admin-link',
		defaultMessage: 'Configure this custom field',
		description:
			'Link text that redirects to upgrade JSM edition for admin users when the CMDB field does not have a valid object shema configured.',
	},
	errorInvalidFieldConfigDowngradedAdminCmdbAssets: {
		id: 'issue-field-cmdb-object.error.error-invalid-field-config-downgraded-admin-cmdb-assets',
		defaultMessage:
			'Assets is not available in this Jira instance. <a>Upgrade to Premium</a> to re-enable Assets and see this data.',
		description:
			'Error message with link to upgrade to premium for admin users when the JSM edition has been downgraded from Premium.',
	},
	errorInvalidFieldConfigDowngradedCmdbAssets: {
		id: 'issue-field-cmdb-object.error.error-invalid-field-config-downgraded-cmdb-assets',
		defaultMessage:
			'Assets is not available in this Jira instance. Please contact your admin to upgrade to premium to re-enable Assets and see this data.',
		description:
			'Error message for non-admin users when the JSM edition has been downgraded from Premium.',
	},
	errorInvalidFieldConfigDisabledCmdbAssets: {
		id: 'issue-field-cmdb-object.error.error-invalid-field-config-disabled-cmdb-assets',
		defaultMessage: 'Assets is not available in this Jira instance.',
		description: 'Error message for all users when CMDB is not enabled on their instance.',
	},
	errorFetchingObjectsCmdbAssets: {
		id: 'issue-field-cmdb-object.error.error-fetching-objects-cmdb-assets',
		defaultMessage:
			'There was a problem loading the Assets objects. Please refresh the page to try again.',
		description:
			'Error message when a failure occurs whilst fetching CMDB objects. Instructs the user to refresh to try again.',
	},
	errorUnknown: {
		id: 'issue-field-cmdb-object.error.error-unknown',
		defaultMessage:
			'Something went wrong. Please refresh the page or contact your admin if the problem persists.',
		description:
			'Error message for an unknown error state. This message instructs the user to refresh to try agagin',
	},
});
